import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavItem, NavItemsType } from '@pt/pt-models';

@Component({
  selector: 'pt-navbar-item',
  template: `
    <ng-container [ngSwitch]="item?.type">
      <ng-container *ngSwitchCase="NavItemsType.SEPARATOR">
        <hr
          class="pt-navbar-item--separator"
          *ngxPermissionsOnly="item.permissVisible"
        />
      </ng-container>

      <pt-navbar-button-item
        *ngSwitchCase="NavItemsType.BUTTON"
        [item]="item"
        (clickAction)="clickAction.emit($event)"
      >
      </pt-navbar-button-item>

      <pt-navbar-logo-item *ngSwitchCase="NavItemsType.LOGO" [item]="item">
      </pt-navbar-logo-item>

      <pt-navbar-any-permission
        *ngSwitchCase="NavItemsType.ANY_PERMISSION"
        [item]="item"
      >
      </pt-navbar-any-permission>

      <pt-navbar-legal-entity-item
        *ngSwitchCase="NavItemsType.LEGAL_ENTITY"
        [item]="item"
      >
      </pt-navbar-legal-entity-item>

      <pt-navbar-user-item *ngSwitchCase="NavItemsType.USER" [item]="item">
      </pt-navbar-user-item>

      <pt-navbar-session-notification-item
        *ngSwitchCase="NavItemsType.SESSION_NOTIFICATION"
        [item]="item"
      >
      </pt-navbar-session-notification-item>

      <pt-navbar-menu-item
        *ngSwitchCase="NavItemsType.MENU"
        [item]="item"
        (clickAction)="clickAction.emit($event)"
      >
      </pt-navbar-menu-item>

      <pt-candidates-menu-item
        *ngSwitchCase="NavItemsType.CANDIDATES"
        [item]="item"
        (clickAction)="clickAction.emit($event)"
      >
      </pt-candidates-menu-item>

      <pt-navbar-support-item
        *ngSwitchCase="NavItemsType.SUPPORT"
        [item]="item"
        (clickAction)="clickAction.emit($event)"
      >
      </pt-navbar-support-item>
    </ng-container>
  `,
  styles: [
    `
      .pt-navbar-item--separator {
        margin: 0;
        height: 0;
      }
    `,
  ],
})
export class NavItemComponent {
  @Input() item: NavItem;

  @Output() clickAction = new EventEmitter<NavItem>();

  NavItemsType = NavItemsType;
}
